export default () => ({
    testRightNum: 0,
    gameNum: 0
});
